import { lt } from '@mews/framework';
import { EmptyStateProps, Link, Stack, StackItem } from '@optimus-web/core';
import { CreateCentralProductButton } from '../CentralProductForm/CreateCentralProductButton';

export const tableEmptyState: EmptyStateProps = {
    primaryText: lt('CentralProductEmptyStatePrimaryText'),
    secondaryText: lt('CentralProductEmptyStateSecondaryText'),
    action: (
        <Stack vertical spacing="300" itemAlignment="center">
            <StackItem>
                <CreateCentralProductButton variant="primary" />
            </StackItem>
            <Link standalone>{lt('LearnMoreAboutProducts')}</Link>
        </Stack>
    ),
};
